import { toastError } from '@components/Toast';

import { fetchTotalLikeCount } from '@store/favourite/actions';
import * as actionTypes from '@store/material/action-types';

import ApiClient from '@lib/apiClient';

export const fetchGarmentsDetails = (id) => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getGarmentsDetails', id);
		dispatch({
			type: actionTypes.FETCH_GARMENTS_DETAILS_SUCCESS,
			payload: { type: 'GARMENTS', data: response.data }
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_GARMENTS_DETAILS_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchFabricDetails = (id) => async (dispatch) => {
	if (id !== undefined) {
		try {
			const response = await ApiClient.GET('getFabricWithSupplierDetails', id);
			dispatch({
				type: actionTypes.FETCH_FABRIC_DETAILS_SUCCESS,
				payload: { type: 'FABRIC', data: response.data }
			});
		} catch (error) {
			dispatch({ type: actionTypes.FETCH_FABRIC_DETAILS_FAILURE });
			if (error.message) {
				toastError(error.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	} else {
		dispatch({
			type: actionTypes.FETCH_FABRIC_DETAILS_SUCCESS,
			payload: { type: 'FABRIC', data: null }
		});
	}
};

export const fetchEmbellishmentDetails = (id) => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getEmbellishmentDetails', id);
		dispatch({
			type: actionTypes.FETCH_EMBELLISHMENT_DETAILS_SUCCESS,
			payload: { type: 'EMBELLISHMENT', data: response.data }
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_EMBELLISHMENT_DETAILS_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchTrimsDetails = (id) => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getTrimsDetails', id);
		dispatch({
			type: actionTypes.FETCH_TRIMS_DETAILS_SUCCESS,
			payload: { type: 'TRIMS_ACCESSORIES', data: response.data }
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_TRIMS_DETAILS_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchBrandingDetails = (id) => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getBrandingDetails', id);
		dispatch({
			type: actionTypes.FETCH_BRANDING_DETAILS_SUCCESS,
			payload: { type: 'BRANDING', data: response.data }
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_BRANDING_DETAILS_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchWashingDetails = (id) => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getWashingDetails', id);
		dispatch({
			type: actionTypes.FETCH_WASHING_DETAILS_SUCCESS,
			payload: { type: 'WASHING', data: response.data }
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_WASHING_DETAILS_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchMaterialSuppliers =
	(page = 0, size = 20, supplierId, sort) =>
	async (dispatch) => {
		try {
			let params = `${supplierId}?page=${page}&size=${size}&sort=${sort}`;
			const response = await ApiClient.GET('getMaterialSuppliers', params);
			dispatch({
				type:
					page > 0
						? actionTypes.FETCH_MORE_MATERIAL_SUPPLIERS_SUCCESS
						: actionTypes.FETCH_MATERIAL_SUPPLIERS_SUCCESS,
				payload: response.data
			});
		} catch (error) {
			dispatch({ type: actionTypes.FETCH_MATERIAL_SUPPLIERS_FAILURE });
			if (error.message) {
				toastError(error.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

export const fetchPinnedMaterials = (item) => async (dispatch) => {
	try {
		let params = '';
		if (item.productId) {
			params += `?productId=${item.productId}`;
		}
		if (item.collectionId) {
			params += `?collectionId=${item.collectionId}`;
		}
		const response = await ApiClient.GET('getPinnedMaterial', params);
		dispatch({
			type: actionTypes.FETCH_PINNED_MATERIALS_SUCCESS,
			payload: {
				...response.data,
				materialResponseList: response?.data?.materialTableResponseList?.map((item) => {
					return {
						...item
					};
				})
			}
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_PINNED_MATERIALS_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const likeMaterial = (id, onSetLikeAndUnlike) => async (dispatch) => {
	try {
		const response = await ApiClient.POST('materialAction', {}, `${id}/like`);
		if (response?.data?.success) {
			dispatch(fetchTotalLikeCount());
			onSetLikeAndUnlike && onSetLikeAndUnlike(id, true);
			return response.data.success;
		}
	} catch (error) {
		onSetLikeAndUnlike && onSetLikeAndUnlike(null, false);
		dispatch({ type: actionTypes.LIKE_MATERIAL_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const unlikeMaterial = (id) => async (dispatch) => {
	try {
		const response = await ApiClient.POST('materialAction', {}, `${id}/unlike`);
		// dispatch({
		// 	type: actionTypes.UNLIKE_MATERIAL_SUCCESS
		// });

		if (response.status === 200) {
			dispatch(fetchTotalLikeCount());
			return response.data.success;
		}
	} catch (error) {
		dispatch({ type: actionTypes.UNLIKE_MATERIAL_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};
